export default "__VITE_ASSET__CvYZ7IhW__"